import React, { useEffect } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { C2B_LEAD_TYPES } from "../../../constants/seller-lead-types";
import { Breadcrumbs } from "@cars24/turbo-web/lib/breadcrumbs";
import { appUrl } from "../../../constants/url-constants";
import VasCmsMetaTags from "../../shared/vas-cms-meta-tags";
import { sendCustomGaEvents } from "../../../tracking";
import { getComponent } from "./selector";
import isObjectEmpty from "../../../utils/helpers/isObjectEmpty";
import PageLoader from "../../shared/page-loader";
import PageNotFound from "../../shared/page-not-found";
import { useParams } from "react-router";

const CityPreDeliveryInspection = ({
    isSsr,
    getPdiPageDataConnect,
    setSSRStatusConnect,
    updateLeadSourceConnect,
    cmsDetails = {},
    source,
    setGaSourceConnect,
    isInvalidCity
}) => {
    const { city = "" } = useParams();
    const { breadcrumb = [], pageSections = [] } = cmsDetails || {};

    useEffect(() => {
        updateLeadSourceConnect(C2B_LEAD_TYPES.CAR_TRUTH_VAS);
        setSSRStatusConnect(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (source) {
            sendCustomGaEvents({us_vas_page_source: source});
            setGaSourceConnect(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [source]);

    useEffect(() => {
        if (!isSsr && isObjectEmpty(cmsDetails)) {
            getPdiPageDataConnect(city);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSsr]);

    if (isInvalidCity) {
        return <PageNotFound />;
    }

    if (isObjectEmpty(cmsDetails)) {
        return <PageLoader/>;
    }

    return (
        <React.Fragment>
            <VasCmsMetaTags cmsDetails={cmsDetails?.seo?.[0]} />
            {pageSections.map(({pageSection}) => {
                const Component = getComponent(pageSection.name);
                return Component ? <Component details={pageSection} isMobile={false}/> : null;
            })}
            <div styleName={"styles.breadCrumbsWrapper2"}>
                <Breadcrumbs
                    attachSchema
                    baseUrl={appUrl()}
                    list={breadcrumb}
                />
            </div>
        </React.Fragment>
    );
};

CityPreDeliveryInspection.propTypes = {
    isSsr: PropTypes.bool,
    getPdiPageDataConnect: PropTypes.func,
    setSSRStatusConnect: PropTypes.func,
    updateLeadSourceConnect: PropTypes.func,
    cmsDetails: PropTypes.object,
    source: PropTypes.string,
    setGaSourceConnect: PropTypes.func,
    isInvalidCity: PropTypes.bool
};

export default CityPreDeliveryInspection;
